import { Mic, Music, Sparkles, Lightbulb, Wand2, Palette, FlaskConical, PartyPopper, Cpu, Baby } from "lucide-react";
import { motion } from "framer-motion";

const performanceTypes = [
  { icon: Mic, title: "Komedia i Rozrywka", description: "Stand-up, kabaret i teatr improwizacji na Twoje wydarzenie." },
  { icon: Music, title: "Muzyka na Żywo", description: "Profesjonalni muzycy, zespoły i soliści różnych gatunków." },
  { icon: Sparkles, title: "Taniec i Akrobatyka", description: "Widowiskowe pokazy taneczne i akrobatyczne." },
  { icon: Lightbulb, title: "Pokazy Wizualne", description: "Efektowne show świetlne, laserowe i multimedialne." },
  { icon: Wand2, title: "Magia i Iluzja", description: "Pokazy magii, sztuczek i iluzji." },
  { icon: Palette, title: "Sztuka i Warsztaty", description: "Interaktywne warsztaty i pokazy artystyczne." },
  { icon: FlaskConical, title: "Nauka i Technologia", description: "Edukacyjne pokazy naukowe i technologiczne." },
  { icon: Cpu, title: "Technologia i AI", description: "Futurystyczne atrakcje z AI, robotami, dronami i VR." },
  { icon: Baby, title: "Dla Dzieci", description: "Animacje, zabawy i atrakcje dla najmłodszych." },
  { icon: PartyPopper, title: "Pozostałe Atrakcje", description: "Unikalne formy rozrywki na specjalne okazje." },
];

export const FormsOfComedy = () => {
  return (
    <section className="py-24 bg-white relative">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Rodzaje występów</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-primary">
            Kategorie atrakcji
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {performanceTypes.map((form, i) => {
            const Icon = form.icon;
            return (
              <motion.div
                key={form.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.05 * i }}
                className="flex gap-4 p-5 rounded-xl hover:bg-secondary/50 transition-all group cursor-default"
              >
                <div className="w-10 h-10 rounded-lg bg-primary flex items-center justify-center flex-shrink-0 group-hover:bg-accent transition-colors">
                  <Icon className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="font-montserrat font-bold text-primary mb-1">{form.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{form.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
